/*
 * @Descripttion: mutations
 * @Author: juanjuanhui
 * @Date: 2021-08-06 14:23:21
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2021-12-13 10:38:56
 */
import * as types from "./types";
const mutations = {
  [types.GET_USER_INFO](state, payload) {
    state.userInfo = payload;
  },
  [types.GET_ACCESS_TOKEN](state, payload) {
    state.accessToken = payload;
  },
  setIsShowSideBar(state, payload) {
    state.isShowSideBar = payload;
  },
  setHeadMenu(state, payload) {
    state.headMenu = payload;
  },
  setBdCurrentTab(state, payload) {
    state.bdCurrentTab = payload;
  },
};
export default mutations;
